<template>
    <!-- <div class="header index_top_header"> -->
    <div class="header">
        <div class="header_top_box">
            <div class="main_box">
                <div class="item_box">
                    <span @click="toMediaMatrix">公众号矩阵</span>
                </div>
                <div class="item_box">
                    <span @click="toPageFn">股鲸</span>
                </div>
                <div class="item_box">
                    <span>签到360</span>
                    <div class="img_box">
                        <img src="https://img.capwhale.com/mpcode_sign360.jpg" alt="">
                        <p>签到360小程序</p>
                    </div>
                </div>
                <!--<div class="item_box">-->
                    <!--<span>鲸活动</span>-->
                    <!--<div class="img_box">-->
                        <!--<img src="https://img.capwhale.com/mpcode_eventcapwhale.jpg" alt="">-->
                        <!--<p>鲸活动小程序</p>-->
                    <!--</div>-->
                <!--</div>-->
                <div class="item_box">
                    <span>精品投研</span>
                    <div class="img_box">
                        <img src="https://img.capwhale.com/mpcode_report.jpg" alt="">
                        <p>精品投研小程序</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="header_main">
            <div class="header_content">
                <!-- <router-link class="logo_img" to="/"></router-link> -->
                
                <a v-if="user.isLogin" class="logo_img" :href="`https://www.capwhale.com/?token=${user.loginToken}`"></a>
                <a v-else class="logo_img" href="https://www.capwhale.com/"></a>

                <!-- <a v-if="user.isLogin" class="a_index" :href="`https://www.capwhale.com/?token=${user.loginToken}`" target="_blank">首页</a>
                <a v-else class="a_index" href="https://www.capwhale.com/" target="_blank">首页</a> -->
                <router-link class="a_index" to="/">首页</router-link>
                <!-- <router-link class="a_index" to="/p/about">关于</router-link> -->
                <el-popover
                    placement="bottom"
                    width="192"
                    trigger="hover">
                    <div v-if="user.isLogin" class="channel_select">
                        <a :href="`https://www.capwhale.com/?token=${user.loginToken}`">资讯</a>
                        <a :href="`https://hd.capwhale.com/?token=${user.loginToken}`">活动</a>
                        <a :href="`https://live.capwhale.com/?token=${user.loginToken}`">直播</a>
                        <a @click="clickToReport">报告</a>
                        <a :href="`https://hr.capwhale.com/`">人才</a>
                    </div>
                    <div v-else class="channel_select">
                        <a :href="`https://www.capwhale.com/`">资讯</a>
                        <a :href="`https://hd.capwhale.com/`">活动</a>
                        <a :href="`https://live.capwhale.com/`">直播</a>
                        <a @click="clickToReport">报告</a>
                        <a :href="`https://hr.capwhale.com/`">人才</a>
                    </div>
                    <p class="channel_text" slot="reference">导航<img :src="require('@/common/images/header/icon5.png')" alt=""></p>
                </el-popover>
                
                
                <div class="search_box">
                    <div class="selcet_box">
                        {{searchType}}
                        <img class="img_blue" :src="require('@/common/images/report/arrow_icon.png')" alt="">
                        <img class="img_white" :src="require('@/common/images/report/arrow_icon2.png')" alt="">
                        <div class="selcet_sub_box">
                            <p @click="selectSearchType(item)" :class="searchType === item ? 'p_active' : ''" v-for="(item, index) in searchTypeData" :key="index">{{item}}</p>
                        </div>
                    </div>
                    <input placeholder="输入关键字搜索相关课程/题库" type="text" autocomplete="off" v-model="searchData">
                    <button @click="search">搜索</button>
                </div>
                <div class="handle_icon_box">
                    <el-popover
                        placement="bottom"
                        width="110"
                        trigger="hover">
                        <div class="icon_popover_box">
                            <img style="width: 110px; height: 110px;" :src="require('@/common/images/header/gz_code.png')" alt="">
                            <p>关注微信公众号</p>
                        </div>
                        <div class="icon_box" slot="reference">
                            <div class="icon_img icon_img1"></div>
                            <span>关注</span>
                        </div>
                    </el-popover>

                    <el-popover
                        placement="bottom"
                        width="120"
                        trigger="hover">
                        <div class="icon_popover_box">
                            <img style="width: 120px; height: 120px;" :src="require('@/common/images/header/kkhz_code.jpg')" alt="">
                            <p style="font-size: 12px;">开课合作请联系微信</p>
                            <p style="font-size: 12px;">电话：13066904312</p>
                        </div>
                        <div class="icon_box" slot="reference">
                            <div class="icon_img icon_img2"></div>
                            <span>开课合作</span>
                        </div>
                    </el-popover>

                    <div @click="uploadingClick" v-for="(item,index) in moreData" :key="index">
                        <div :class="item.iconClass" class="icon_img"></div>
                        <span>{{item.title}}</span>
                    </div>
                </div>
                <el-popover
                    placement="bottom-end"
                    width="212"
                    trigger="hover">
                    <div class="user_popover_box">
                        <p>登录使用更多功能</p>
                        <el-button @click="loginBtn" type="primary">登录/注册</el-button>
                    </div>
                    <div v-show="!user.isLogin" class="user_img" slot="reference"></div>
                </el-popover>
                <el-popover
                    placement="bottom-end"
                    width="212"
                    trigger="hover">
                    <div class="login_user_popover">
                        <div @click="gotoRouterPersonalCenter">
                            <img class="cursor" :src="user.logourl === '' ? require('@/common/images/header/user.png') : user.logourl" alt="">
                            <span class="cursor">{{user.nickname}}</span>
                        </div>
                        <span @click="exitLogin">退出登录</span>
                    </div>
                    <div v-show="user.isLogin" class="user_img log_user_info" slot="reference">
                        <img @click="gotoRouterPersonalCenter" :src="user.logourl === '' ? require('@/common/images/header/user.png') : user.logourl" alt="">
                    </div>
                </el-popover>
            </div>
        </div>
        <input placeholder="输入关键字搜索相关课程/题库" type="text" autocomplete="off" style="width:0; height: 0; border:none">
        <!-- 隐藏掉用户保存的账号密码 -->
    </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import $ from 'jquery'
export default {
    name: 'pageHeader',
    data() {
        return {
            searchType: '全部',
            searchTypeData: ['全部', '报告' ,'课程' ,'题库'],
            searchData: '',
            moreData: [
                {
                    title: '上传',
                    iconClass: 'icon_img3'
                }
                // {
                //     title: '消息',
                //     iconClass: 'icon_img4'
                // },
            ]
        }
    },
    mounted() {
        // 判断是否为Searcg 页面
        this.justSearch()
        var _hmt = _hmt || [];
        (function() {
        var hm = document.createElement("script");
        hm.src = "https://hm.baidu.com/hm.js?b9bf0cffeb4e0a7f99503096e7a4f807";
        var s = document.getElementsByTagName("script")[0]; 
        s.parentNode.insertBefore(hm, s);
        })();
    },
    methods: {
        toPageFn() {
            window.open(`https://gj.capwhale.com/gjindex`)
        },
        clickToReport() {
            if (this.user.loginToken) {
                window.open(`${this.domainlist.url_report}/reportindex?token=${this.user.loginToken}`)
            } else {
                window.open(`${this.domainlist.url_report}/reportindex`)
            }
        },
        // 媒体矩阵
        toMediaMatrix() {
            this.$router.push({name: 'MediaMatrix1'})
        },
        // 搜索框前面选择搜索内型
        selectSearchType (val) {
            this.searchType = val
        },
        justSearch() {
            let pageName = this.$router.history.current.name
            if (pageName == "Search") {
                this.searchData = this.$route.query.data
            }
        },
        // 登录、注册弹窗
        loginBtn() {
            this.setLoginPop(true)
        },
        search() {  // 搜索课程
            let domain = 1
            if(window.location.hostname.indexOf('ke.capwhale.com')>=0){
                domain = 1
            } else {
                domain = 2
            }
            // console.log(this.searchType)
            switch(this.searchType) {
                case '全部':
                    this.$router.push({name: 'AllSearch',query: {data: this.searchData}})
                    break;
                case '报告':
                    if (domain === 1) {
                        // location.href = `${this.domainlist.url_course}/search?data=${this.searchData}&searchtype=1`
                        window.open(`${this.domainlist.url_report}/reportsearch?data=${this.searchData}&token=`+this.user.loginToken)
                    } else {
                        this.$router.push({name: 'ReportSearch',query: {data: this.searchData}})
                    }
                    break;
                case '课程':
                    this.$router.push({name: 'Search',query: {data: this.searchData}})
                    break;
                case '题库':
                    this.$router.push({name: 'QuestionSearch',query: {data: this.searchData}})
                    break;
                case '活动':
                    this.$router.push({name: 'HdSearch',query: {data: this.searchData}})
                    break;
            }
            // if (this.searchData.length > 0) {
            //     this.$router.push({name: 'ReportSearch',query: {data: this.searchData}})
            // } else {
            //     this.$router.push({name: 'ReportSearch'})
            // }
        },
        // 退出登录
        exitLogin() {
            window.sessionStorage.clear()
            let user = {
                innerid: '',
                loginToken: '',
                loginname: '',
                logourl: '',
                mobile: '',
                name: '',
                nickname: '',
                isLogin: false
            }
            this.setUser(user)
            this.$message.success('退出成功！')
        },
        // 前往个人中心页面
        gotoRouterPersonalCenter() {
            // this.$router.push({name: 'ClassScheduleCard'})
            if (this.user.loginToken) {
                window.location.replace(`${this.domainlist.url_my}/personalCenter/ClassScheduleCard?token=${this.user.loginToken}&type=1`)
            } else {
                window.location.replace(`${this.domainlist.url_my}/personalCenter/ClassScheduleCard&type=1`)
            }
        },
        // 上传点击跳转到https://admin.jkt.capwhale.com/login
        uploadingClick() {
            if (this.user.isLogin) {
                window.open('https://czadmin.capwhale.com/creativeCenter?token=' + this.user.loginToken, '_blank')
            } else {
                window.open('https://czadmin.capwhale.com/login', '_blank')
            }
        },
        ...mapActions([
            'setLoading',
            'setLoginPop',
            'setUser'
        ])
    },
    watch: {
        $route: {
            handler (val) { // val 更新的, oldVal 过去的
                this.justSearch()
                // index 页面下样式删除
                if (val.name !== "Index") {
                    // console.log('删除')
                    $(".PHome .header").removeClass("index_top_header")
                } else {
                    // index 页面下样式绑定
                    $(".PHome .header").addClass("index_top_header")
                }
            },
            // 深度观察监听
            deep: true
        }
    },
    filters: {},
    computed: {
        ...mapGetters(
            ['user', 'domainlist']
        )
    },
    components: {

    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
    .header{
        // height:80px;
        // height: 0;
        position: relative;
        z-index: 100;
        width: 100%;
        font-family:PingFangSC-Regular,PingFang SC;
        position: fixed;
        top: 0;
        .cursor {
            cursor: pointer;
        }
        .header_top_box{
            height: 32px;
            background-color: #f0f0f0;
            color: #666;
            display: flex;
            justify-content: center;
            .main_box {
                width: 1200px;
                display: flex;
                justify-content: flex-end;
                padding: 0 20px;
                box-sizing: border-box;
                .item_box {
                    position: relative;
                    display: flex;
                    align-items: center;
                    margin-left: 24px;
                    &>span{
                        cursor: pointer;
                        font-size: 12px;
                    }
                    .img_box {
                        position: absolute;
                        top: 32px;
                        left: -50px;
                        height: 0;
                        opacity: 0;
                        z-index: -2;
                        overflow: hidden;
                        -webkit-transition: all .3s;
                        -moz-transition: all .3s;
                        -ms-transition: all .3s;
                        -o-transition: all .3s;
                        transition: all .3s;

                        border-radius: 8px;
                        padding: 10px 20px;
                        background-color: #FFF;
                        box-shadow:0px 0px 6px 0px rgba(0,0,0,0.2);
                        &>img{
                            width: 120px;
                            height: 120px;
                        }
                        &>p {
                            margin-top: 10px;
                            font-size: 14px;
                            text-align: center;
                        }
                    }
                }
                .item_box:hover {
                    .img_box {
                        opacity: 1;
                        height: 150px;
                        z-index: 200;
                    }
                }
            }
        }
        .header_main {
            display: flex;
            justify-content: center;
            // position: fixed;
            // top: 0;
            width: 100%;
            height:80px;
            background:rgba(255,255,255,1);
            box-shadow:0px 2px 8px 0px rgba(204,204,204,1);
            .header_content {
                // background-color: pink;
                padding: 0 20px;
                box-sizing: border-box;
                width: 1200px;
                min-width: 1200px;
                display: flex;
                align-items: center;
                .logo_img {
                    width: 95px;
                    height: 33px;
                    background-image: url('../../common/images/header/new_logo1.png');
                    background-size:95px 33px;
                }
                .a_index {
                    color: #409EFF;
                    font-size:18px;
                    margin-left: 63px;
                    margin-right: 30px;
                    // &.router-link-exact-active {
                    //     color: #42b983;
                    // }
                }
                .channel_text {
                    font-size:18px;
                    cursor: pointer;
                    color: #333333;
                    display: flex;
                    align-items: center;
                    &>img{
                        width: 8px;
                        height: 8px;
                        margin-left: 8px;
                    }
                }
                .search_box {
                    margin-left: 80px;
                    margin-right: 115px;
                    display: flex;
                    .selcet_box {
                        border: 2px solid #409EFF;
                        border-right: none;
                        border-radius: 40px 0 0 40px;
                        box-sizing: border-box;
                        width: 70px;
                        background:rgba(230,241,252,1);
                        color: #409EFF;
                        font-size: 14px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        cursor: pointer;
                        position: relative;
                        &>img {
                            margin-top: 2px;
                            width: 7px;
                            height: 5px;
                            margin-left: 4px;
                        }
                        .img_blue {
                            display: block;
                        }
                        .img_white {
                            display: none;
                        }
                        .selcet_sub_box {
                            // padding-top: 6px;
                            display: none;
                            position: absolute;
                            bottom: -122px;
                            // background-color: #fff;
                            border-radius:4px;
                            background-color: transparent;
                            box-shadow: 0 0.02667rem 0.05333rem rgba(0, 0, 0, 0.12), 0 0 0.08rem rgba(0, 0, 0, 0.04);
                            &>p {
                                background-color: #fff;
                                width: 70px;
                                height: 30px;
                                line-height: 30px;
                                text-align: center;
                                font-size: 14px;
                                color: #333;
                            }
                            &>p:nth-of-type(1) {
                                border-radius:4px 4px 0px 0px;
                            }
                            &>p:nth-last-of-type(1) {
                                border-radius: 0 0 4px 4px;
                            }
                            &>p:hover {
                                color: #409EFF;
                                background-color: #E6F1FC;
                            }
                            .p_active {
                                color: #409EFF;
                                background-color: #E6F1FC;
                            }
                        }
                        
                    }
                    .selcet_box:hover {
                        .selcet_sub_box {
                            display: block;
                        }
                    }
                    &>input{
                        width: 296px;
                        height: 36px;
                        border: 2px solid #409EFF;
                        // border-radius: 20px 0 0 20px;
                        border-right: none;
                        border-left: none;
                        padding-left: 20px;
                    }
                    &>input::-webkit-input-placeholder{
                        color: #999999;
                    }
                    &>input:-ms-input-placeholder{
                        color: #999999;
                    }
                    &>input::-moz-placeholder{
                        color: #999999;
                    }
                    &>input:focus{
                        outline: none;
                    }
                    &>button{
                        float: right;
                        cursor: pointer;
                        background-color: #409EFF;
                        color: #FFF;
                        border: none;
                        width: 82px;
                        height: 40px;
                        border-radius: 0 20px 20px 0;
                    }
                    &>button:focus{
                        outline: none;
                    }
                    &>button:active{
                        background-color: rgb(100, 173, 247);
                    }
                }
                .handle_icon_box {
                    // margin-left: 26px;
                    display: flex;
                    .icon_box {
                        cursor: pointer;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        margin-right: 28px;
                        .icon_img {
                            width: 22px;
                            height: 22px;
                            margin-bottom: 6px;
                            background-size:22px 22px;
                        }
                        .icon_img1 {
                            background-image: url('../../common/images/header/icon1.png');
                        }
                        .icon_img2 {
                            background-image: url('../../common/images/header/icon2.png');
                        }
                        span{
                            line-height: 17px;
                            color: #999999;
                            font-size: 12px;
                        }
                    }
                    .icon_box:hover {
                        .icon_img1 {
                            background-image: url('../../common/images/header/icon1_blue.png');
                        }
                        .icon_img2 {
                            background-image: url('../../common/images/header/icon2_blue.png');
                        }
                        span{
                            color: #409EFF;
                        }
                    }
                    &>div {
                        cursor: pointer;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        margin-right: 24px;
                        .icon_img {
                            width: 22px;
                            height: 22px;
                            margin-bottom: 6px;
                            background-size:22px 22px;
                        }
                        .icon_img3 {
                            background-image: url('../../common/images/header/icon3.png');
                        }
                        .icon_img4 {
                            background-image: url('../../common/images/header/icon4.png');
                        }
                        span{
                            line-height: 17px;
                            color: #999999;
                            font-size: 12px;
                        }
                    }
                    &>div:hover {
                        .icon_img3 {
                            background-image: url('../../common/images/header/icon3_blue.png');
                        }
                        .icon_img4 {
                            background-image: url('../../common/images/header/icon4_blue.png');
                        }
                        span{
                            color: #409EFF;
                        }
                    }
                }
                .user_img {
                    cursor: pointer;
                    width: 40px;
                    height: 40px;
                    background-image: url('../../common/images/header/user_icon.png');
                    background-size:40px 40px;
                    // margin-left: 70px;
                    &>img {
                        width: 40px;
                        height: 40px;
                        border-radius: 20px;
                    }
                }
                .log_user_info {
                    background-image:none!important;
                }
            }
        }
    }
    .index_top_header {
        .header_main {
            background: transparent!important;
            box-shadow:none;
            .header_content {
                .logo_img {
                    background-image: url('../../common/images/header/logo2.png');
                }
                .a_index {
                    display: none;
                }
                .channel_text {
                    display: none;
                }
                .search_box {
                    margin-left: 218px;
                    margin-right: 160px;
                    .selcet_box {
                        border: none;
                        background:rgba(255,255,255,0.2);
                        color: #fff;
                        .img_blue {
                            display: none;
                        }
                        .img_white {
                            display: block;
                        }
                        .selcet_sub_box {
                            bottom: -121px;
                            &>p {
                                background:rgba(255,255,255,0.4);
                                color: #fff;
                            }
                            &>p:hover {
                                color: #409EFF;
                                background:rgba(255,255,255,0.4);
                            }
                            .p_active {
                                color: #409EFF;
                                background:rgba(255,255,255,0.4);
                            }
                        }
                        
                    }
                    .selcet_box:hover {
                        .selcet_sub_box {
                            display: block;
                        }
                    }
                    &>input{
                        color: #FFF;
                        width: 296px;
                        height: 40px;
                        border: none;
                        background:rgba(255,255,255,0.2);
                    }
                    &>input::-webkit-input-placeholder{
                        color: #FFF;
                    }
                    &>input:-ms-input-placeholder{
                        color: #FFF;
                    }
                    &>input::-moz-placeholder{
                        color: #FFF;
                    }
                }
                .handle_icon_box {
                    .icon_box {
                        .icon_img1 {
                            background-image: url('../../common/images/header/icon1_1.png');
                        }
                        .icon_img2 {
                            background-image: url('../../common/images/header/icon2_1.png');
                        }
                        span{
                            color: #fff;
                        }
                    }
                    &>div {
                        .icon_img1 {
                            background-image: url('../../common/images/header/icon1_1.png');
                        }
                        .icon_img2 {
                            background-image: url('../../common/images/header/icon2_1.png');
                        }
                        .icon_img3 {
                            background-image: url('../../common/images/header/icon3_1.png');
                        }
                        .icon_img4 {
                            background-image: url('../../common/images/header/icon4_1.png');
                        }
                        span{
                            color: #fff;
                        }
                    }
                }
                .user_img {
                    background-image: url('../../common/images/header/user_icon2.png');
                }
            }
        }
    }
    .el-popover {
        min-width: 100px!important;
    }
    .channel_select {
        box-sizing: border-box;
        padding: 0 8px;
        display: flex;
        justify-content: space-between;
        a{
            color: #666666;
            cursor: pointer;
        }
        a:hover{
            color: #409EFF;
        }
    }
    .user_popover_box {
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 8px 14px;
        &>p {
            line-height:20px;
            color: #999999;
            margin-bottom: 14px;
        }
        .el-button {
            width: 210px;
            height: 34px;
            border-radius: 20px;
            padding: 0;
        }
    }
    .login_user_popover {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 4px 0;
        &>div{
            display: flex;
            align-items: center;
            &>img {
                width: 40px;
                height: 40px;
                border-radius: 20px;
                margin-right: 12px;
            }
            &>span {
                white-space: nowrap;
                color: #333;
            }
        }
        &>span {
            color: #409EFF;
            cursor: pointer;
        }
        &>span:hover {
            color: rgb(10, 127, 245);
        }
    }
    .icon_popover_box{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        &>p {
            color: #333333;
            line-height: 20px;
        }
    }
</style>